__turbopack_context__.v({
  "actions": "PhotoStudioLanding-module__btRqFW__actions",
  "collection": "PhotoStudioLanding-module__btRqFW__collection",
  "container": "PhotoStudioLanding-module__btRqFW__container",
  "enlarge": "PhotoStudioLanding-module__btRqFW__enlarge",
  "exampleLabel": "PhotoStudioLanding-module__btRqFW__exampleLabel",
  "eyebrow": "PhotoStudioLanding-module__btRqFW__eyebrow",
  "faqList": "PhotoStudioLanding-module__btRqFW__faqList",
  "faqSection": "PhotoStudioLanding-module__btRqFW__faqSection",
  "finalInner": "PhotoStudioLanding-module__btRqFW__finalInner",
  "finalSection": "PhotoStudioLanding-module__btRqFW__finalSection",
  "hero": "PhotoStudioLanding-module__btRqFW__hero",
  "heroGallery": "PhotoStudioLanding-module__btRqFW__heroGallery",
  "heroMainPhoto": "PhotoStudioLanding-module__btRqFW__heroMainPhoto",
  "heroNote": "PhotoStudioLanding-module__btRqFW__heroNote",
  "intro": "PhotoStudioLanding-module__btRqFW__intro",
  "packCollection": "PhotoStudioLanding-module__btRqFW__packCollection",
  "page": "PhotoStudioLanding-module__btRqFW__page",
  "photoCaption": "PhotoStudioLanding-module__btRqFW__photoCaption",
  "previewBackdrop": "PhotoStudioLanding-module__btRqFW__previewBackdrop",
  "previewClose": "PhotoStudioLanding-module__btRqFW__previewClose",
  "previewDialog": "PhotoStudioLanding-module__btRqFW__previewDialog",
  "previewFrame": "PhotoStudioLanding-module__btRqFW__previewFrame",
  "previewPanel": "PhotoStudioLanding-module__btRqFW__previewPanel",
  "previewTitle": "PhotoStudioLanding-module__btRqFW__previewTitle",
  "primaryButton": "PhotoStudioLanding-module__btRqFW__primaryButton",
  "sectionDescription": "PhotoStudioLanding-module__btRqFW__sectionDescription",
  "sectionNav": "PhotoStudioLanding-module__btRqFW__sectionNav",
  "skipLink": "PhotoStudioLanding-module__btRqFW__skipLink",
  "stepNumber": "PhotoStudioLanding-module__btRqFW__stepNumber",
  "steps": "PhotoStudioLanding-module__btRqFW__steps",
  "studioName": "PhotoStudioLanding-module__btRqFW__studioName",
  "textLink": "PhotoStudioLanding-module__btRqFW__textLink",
  "videoChoices": "PhotoStudioLanding-module__btRqFW__videoChoices",
  "videoCopy": "PhotoStudioLanding-module__btRqFW__videoCopy",
  "videoExample": "PhotoStudioLanding-module__btRqFW__videoExample",
  "videoSection": "PhotoStudioLanding-module__btRqFW__videoSection",
  "workflow": "PhotoStudioLanding-module__btRqFW__workflow",
  "workflowPhotos": "PhotoStudioLanding-module__btRqFW__workflowPhotos",
});
